import { apiClient } from '@/shared/lib/apiClient';
import type {
  AdminMyFatoorahTransactionDetails,
  AdminMyFatoorahTransactionsListResponse,
  ListAdminMyFatoorahTransactionsQuery,
} from '../types/adminMyfatoorahTransaction';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function listAdminMyFatoorahTransactions(
  query?: ListAdminMyFatoorahTransactionsQuery,
): Promise<AdminMyFatoorahTransactionsListResponse> {
  const params: Record<string, string> = {};
  if (query?.cursor) params['cursor'] = query.cursor;
  if (query?.limit !== undefined) params['limit'] = String(query.limit);
  if (query?.status) params['status'] = query.status;
  if (query?.product_id) params['product_id'] = query.product_id;
  if (query?.search) params['search'] = query.search;
  if (query?.from) params['from'] = query.from;
  if (query?.to) params['to'] = query.to;
  if (query?.invoice_id) params['invoice_id'] = query.invoice_id;
  if (query?.payment_id) params['payment_id'] = query.payment_id;

  const res = await apiClient.get<ApiResponse<AdminMyFatoorahTransactionsListResponse>>(
    '/api/v1/admin/payments/myfatoorah/transactions',
    { params },
  );
  return res.data;
}

export async function getAdminMyFatoorahTransactionDetails(
  paymentId: string,
): Promise<AdminMyFatoorahTransactionDetails> {
  const res = await apiClient.get<ApiResponse<AdminMyFatoorahTransactionDetails>>(
    `/api/v1/admin/payments/myfatoorah/transactions/${paymentId}`,
  );
  return res.data;
}
